import { render, staticRenderFns } from "./NewsletterEdit.vue?vue&type=template&id=67444233&scoped=true"
import script from "./NewsletterEdit.vue?vue&type=script&lang=js"
export * from "./NewsletterEdit.vue?vue&type=script&lang=js"
import style0 from "./NewsletterEdit.vue?vue&type=style&index=0&id=67444233&prod&lang=scss"
import style1 from "./NewsletterEdit.vue?vue&type=style&index=1&id=67444233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67444233",
  null
  
)

export default component.exports